import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PreviewDialogComponent } from 'app/preview-dialog/preview-dialog.component';
import { RestApiService } from 'app/shared/restApiServices/restapi.service';
import { RenderZingChartService } from 'app/shared/services/render.zingchart.service';
import { Subject } from 'rxjs';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import { Router } from '@angular/router';
import { superAdminService } from 'app/shared/services/superAdminService';

declare var zingchart: any;
@Component({
  selector: 'app-view-performance',
  templateUrl: './view-performance.component.html',
  styleUrls: ['./view-performance.component.css']
})
export class ViewPerformanceComponent implements OnInit {

  surveyCountRequest: SurveyCountRequest;
  private surveyCountSubject = new Subject<SurveyCountRequest>();
  selectedSurveyName;
  selectedVersion;
  qnrList = [];
  versions = [];
  numVersionResponses=[];
  username = localStorage.getItem("user_name_header");
  superAdmin = false;
  companyName:string;
  switchOrgList:{orgName:string,superAdminID:string}[]=[];

  // map....

  map: L.Map;
  markers: L.Marker[] = [];
  options1 = {
    layers: [
      L.tileLayer('http://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        attribution: 'map'
      })
    ],
    zoom: 16,
    center: { lat: 28.626137, lng: 79.821603 }
  };
  initialMarkers: {position: { lat: number, lng: number },
  draggable: false,
  id:string}[] = [];
  unselected = L.icon({
    iconSize: [20, 20],
    iconAnchor: [7, 13],
    iconUrl: 'assets/images/marker-unselected.svg',
  });
  selected = L.icon({
    iconSize: [20, 20],
    iconAnchor: [7, 13],
    iconUrl: 'assets/images/marker-selected.svg',
  });
  markerClusterData: any[] = [];
  markerClusterGroup: L.MarkerClusterGroup;
  center=[20.5937, 78.9629];
  zoom = 4;
  // map...

  constructor(private graphService:RenderZingChartService, private restApiService: RestApiService,
    private dialog: MatDialog, private router: Router,
    private superAdminService: superAdminService) {
    this.surveyCountSubject.subscribe(response=>{
      if(this.selectedTab2 == 'map'){
        this.getMapViewForSurvey(response);
      }
      else{
        this.getDateUserWiseSurveyCount(response);
      }
    })

    if (this.superAdminService.hasData()) {
      this.superAdmin = this.superAdminService.getData();
    } else {
      this.restApiService.checkIfSuperAdmin().subscribe(
        result => {
          if (result.checkIfSuperAdmin == true) {
            this.superAdmin = true;
            this.superAdminService.setData(this.superAdmin);
          }
          else {
            this.superAdmin = false;
            this.superAdminService.setData(this.superAdmin);
          }
        });
    }
    this.companyName = localStorage.getItem('companyName');
   }

  ngOnInit() {
    this.resetSurveyCountRequest();
    this.getQnrList();
    this.switchOrgList = this.restApiService.getSwitchOrgList();
  }

  onSelectOrg(org:{orgName:string,superAdminID:string}){
    if(org && org.superAdminID && org.superAdminID != undefined && org.orgName && org.orgName){
      localStorage.setItem('superAdminID',org.superAdminID);
      localStorage.setItem('companyName',org.orgName);
      this.companyName = org.orgName;
      // this.restApiService.orgName.next(this.companyName);
      this.goToSurveys();
    }
  }
  openSettings(){
    this.router.navigateByUrl('/userProfile');
  }

  getQnrList(){
    this.restApiService.getQnrListService().subscribe(
      result => {
        this.qnrList = result.result;
        const surveyId = localStorage.getItem("selectedSIdForPerformance");
        this.qnrList.forEach(qnr=>{
          if(qnr.qID == surveyId){
            this.versions= qnr.versions;
          }
        })
      });
  }

  onSelectSurvey(qnr){
    localStorage.setItem("selectedSIdForPerformance",qnr.qID);
    localStorage.setItem("selectedAdminIdForPerformance",qnr.adminID);
    localStorage.setItem("selectedSurveyName",qnr.surveyName);
    this.versions= qnr.versions;
    this.numVersionResponses = qnr.numVersionResponses;
    this.resetSurveyCountRequest();
    this.selectedVersion = null;
  }

  onSelectVersion(version){
    this.selectedVersion = version;
    this.resetSurveyCountRequest(version);
  }

  onSelectAllVersion(){
    this.selectedVersion = null;
    this.resetSurveyCountRequest();
  }
  onSelectSurveyor(surveyor){
    const surveyorList = this.surveyorList;
    const data={
      surveyor: surveyor,
      surveyorList : surveyorList,
      surveyId: localStorage.getItem("selectedSIdForPerformance"),
      selectedResponse:null,
      responseList : null,
      dialogType:'surveyor',
    }
    let dialogRef = this.dialog.open(PreviewDialogComponent,{
      panelClass:'custom-dialog-class',
      width: '800px',
      height: '443px',
      data: data,
      disableClose:true
    })
    dialogRef.afterClosed().subscribe(res=>{
    })
  }

  selectedTab1 : 'responses'|'surveyors' = 'responses';
  selectedTab2 : 'graph'|'map' = 'graph';
  selectedTab3 : 'all'|'last7days'|'last30days' = 'all';

  chartId = 'myCustomGraph';

  surveyorList: {sno:number,surveyor:string,mobileNo:string,responses:number}[]=[];
  displayedColumns: string[] = ['sno', 'surveyor', 'mobileNo', 'responses'];
  totalCount = 0;
  responseCount = 0;
  responseList=[];

  createResponseGraph(response){
    let yData = [];
    let xData = [];
    if(response && response.length>0){
      response.forEach(data=>{
        yData.push(data.count);
        xData.push(data.property?data.property.substring(0,10):'');
        data.property = data.property?data.property.substring(0,10):'';
      })
    }
    for (let index = 0; index < yData.length; index++) {
      yData[index] = Number(yData[index]);
    }
    const graphData = [{ values: yData,
      'background-color':'#009688'}];
    this.responseList = response;
    let count = 0; 
    this.responseList.forEach(data=> count = count+ +data.count);
    if(!this.surveyCountRequest.startDate && !this.surveyCountRequest.endDate){
      this.totalCount = count;
    }
    this.responseCount = count;
    this.graphService.barChart2(graphData,xData,this.chartId);

    zingchart.bind(this.chartId, 'node_click', (e)=>{
      const selectedResponse = this.responseList[e.nodeindex];
      let responseList:any = this.responseList;
      let count = 0;
      responseList.forEach(data=> {
        data.sno= count;
        count = count+1;
      })
      const data={
        surveyor: null,
        surveyorList : null,
        selectedResponse:selectedResponse,
        responseList : responseList,
        dialogType:'response',
        surveyId: localStorage.getItem("selectedSIdForPerformance")
      }
      let dialogRef = this.dialog.open(PreviewDialogComponent,{
        panelClass:'custom-dialog-class',
        width: '800px',
        height: '443px',
        data: data,
        disableClose:true
      })
      dialogRef.afterClosed().subscribe(res=>{
      })
    },this);
    zingchart.bind(this.chartId, 'contextmenu', function(p) { return false;});
  }

  getSurveyorList(response){
    this.surveyorList = [];
    let index = 1;
    if(response && response.length>0){
      response.forEach(data=>{
        this.surveyorList.push({sno:index,surveyor:data.Name,mobileNo:data.property,responses:data.count});
        index = index+1;
      })
    }
  }


  getDateUserWiseSurveyCount(surveyCountRequest: SurveyCountRequest){
    this.onClickItem = false;
    const adminId = localStorage.getItem("selectedAdminIdForPerformance");
    this.restApiService.getDateUserWiseSurveyCount(adminId,surveyCountRequest.surveyID,surveyCountRequest.type,
      surveyCountRequest.version,surveyCountRequest.startDate,surveyCountRequest.endDate,
      surveyCountRequest.surveyorFilter).subscribe(response=>{
        if(surveyCountRequest.type == 'date'){
          this.createResponseGraph(response);
        }
        else{
          this.getSurveyorList(response);
        }
      })

  }

  mapValues:{name:string,date:string}[]=[];
  getMapViewForSurvey(surveyCountRequest: SurveyCountRequest){
    const adminId = localStorage.getItem("selectedAdminIdForPerformance");
    this.restApiService.getMapViewForSurvey(adminId,surveyCountRequest.surveyID,
      surveyCountRequest.version,surveyCountRequest.startDate,surveyCountRequest.endDate,
      surveyCountRequest.surveyorFilter).subscribe(response=>{
        if(response && response.length>0){
          this.mapValues = [];
          response.forEach(data=>{
            const date = data.survey_date?data.survey_date.substring(0,10):'';
            this.mapValues.push({name:data.Name,date:date});
          })
          this.generateMap(response);
        }
      })

  }

  resetSurveyCountRequest(version?:string){
    let surveyId = localStorage.getItem("selectedSIdForPerformance");
    this.selectedSurveyName  = localStorage.getItem("selectedSurveyName");
    this.surveyCountRequest={
      surveyID:surveyId,
      type:'date',
      version:null,
      startDate:null,
      endDate:null,
      surveyorFilter:null
    }
    if(version){
      this.surveyCountRequest.version = version
    }
    this.selectedTab1 = 'responses';
    this.selectedTab2 = 'graph';
    this.selectedTab3 = 'all';
    this.getDateUserWiseSurveyCount(this.surveyCountRequest);
  }

  formatDate(date) {
    date = date?date:new Date();
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  };

  getResponseData(){
    this.onClickItem = false;
    this.surveyCountRequest.type="date";
    this.surveyCountSubject.next(this.surveyCountRequest);
  }

  getSurveyorData(){
    this.onClickItem = false;
    this.surveyCountRequest.type="surveyor";
    this.surveyCountSubject.next(this.surveyCountRequest);
  }

  last7daysFilter(){
    this.onClickItem = false;
    const date = new Date();
    let last7thDayDate:any = new Date(date.getTime() - 7*24*60*60*1000);
    last7thDayDate = this.formatDate(new Date(last7thDayDate));
    const currentDate = this.formatDate(new Date());
    this.surveyCountRequest.startDate = last7thDayDate;
    this.surveyCountRequest.endDate = currentDate;
    this.surveyCountSubject.next(this.surveyCountRequest);
  }
  last30daysFilter(){
    this.onClickItem = false;
    const date = new Date();
    let last30thDayDate:any = new Date(date.getTime() - 30*24*60*60*1000);
    last30thDayDate = this.formatDate(new Date(last30thDayDate));
    const currentDate = this.formatDate(new Date());
    this.surveyCountRequest.startDate = last30thDayDate;
    this.surveyCountRequest.endDate = currentDate;
    this.surveyCountSubject.next(this.surveyCountRequest);
  }

  allDaysFilter(){
    this.onClickItem = false;
    this.surveyCountRequest.startDate=null;
    this.surveyCountRequest.endDate = null;
    this.surveyCountSubject.next(this.surveyCountRequest);
  }



  onMapReady($event: L.Map) {
    this.map = $event;
    this.initMarkers();
  }
  
  initMarkers() {
    for (let index = 0; index < this.initialMarkers.length; index++) {
      const data = this.initialMarkers[index];
      const marker = this.generateMarker(data, index);
      marker.addTo(this.map).setIcon(this.unselected);
      this.map.panTo(data.position);
      this.markers.push(marker)
    }
  }
  generateMarker(data: any, index: number) {
    return L.marker(data.position, { draggable: data.draggable })
      .on('click', (event) => this.markerClicked(event, index))
      .on('dragend', (event) => this.markerDragEnd(event, index));
  }

  markerClicked($event: any, index: number) {
    const id= this.initialMarkers[index].id
    const position= this.initialMarkers[index].position;
    if (this.prevclick != undefined) {
      this.prevclick.target.setIcon(this.unselected);
    }
    this.prevclick = $event;
  }

  markerDragEnd($event: any, index: number) {
    console.log($event.target.getLatLng());
  } 

  markerClusterReady(group: L.MarkerClusterGroup) {
    this.markerClusterGroup = group;
    let lat1, lng1;
    this.markerClusterGroup.options.iconCreateFunction = function (cluster) {
      return L.divIcon({ html: '<b style="padding:4px; background-color: #FFA17A; text-align: center;font-size: 12px; border-radius:50%; color:#FFFFFF"; font-weight: 500;font-family: "Roboto";font-style: normal;line-height: 14px;">' + cluster.getChildCount() + '</b>', className: 'my-div-icon', iconSize: L.point(40, 40),
      iconAnchor: L.point(7, 12) });
    }
    this.markerClusterGroup.options.maxClusterRadius = 10;
    this.markerClusterGroup.options.singleMarkerMode = true;
  }
  mapClicked($event: any) {
    $event.target.setIcon(this.selected);
    this.zoom=20;
    this.center = [$event.latlng.lat, $event.latlng.lng]
  }

  generateMap(response){
    this.markerClusterData = [];
    this.initialMarkers = [];
    let count = 1;
    for (let i in response) {
      this.initialMarkers.push({position: {lat: parseFloat(response[i].lat), 
        lng: parseFloat(response[i].lng)},
        draggable:false, id: count.toString()});
      this.markerClusterData.push(L.marker([parseFloat(response[i].lat),parseFloat(response[i].lng)],
        {'id': count.toString()}).setIcon(this.unselected).on('click', this.onclick.bind(this)));
      count = count +1;
    }
    // this.map.flyTo([20.5937,78.9629], 5);
    // L.setView(new L.latlng(20.5937, 78.9629), 4);
    this.map.setView( [20.5937, 78.9629], 4);
  }
  prevclick: any;
  onClickItem = false;
  surveyorName:string;
  surveyorDate:string;
  onclick = (e) => {
    if (this.prevclick != undefined) {
      this.prevclick.target.setIcon(this.unselected);
    }
    this.prevclick = e;
    this.onClickItem = true;
    e.target.setIcon(this.selected);
    const index = +e.target.options.id - 1;
    this.surveyorName = this.mapValues[index].name;
    this.surveyorDate = this.mapValues[index].date;
  };

  // route to home page...
  goToSurveys(){
    this.router.navigate(['./questionnaires']);
  }
}



export interface SurveyCountRequest{
  surveyID: string,
  type: "date"|"surveyor",
  version:string,
  startDate:string,
  endDate:string,
  surveyorFilter?:string
}



// WEBPACK FOOTER //
// ./src/app/view-performance/view-performance.component.ts